import React from 'react';

interface MenuSectionProps {
  id?: string;
  title: string;
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  isFirstSection?: boolean;
  isMobileTitle?: boolean;
}

export const MenuSection: React.FC<MenuSectionProps> = ({
  id,
  title,
  children,
  className = "",
  style,
  isFirstSection = false,
  isMobileTitle = false
}) => {
  return (
    <div id={id} className={`side-menu-section ${isFirstSection ? 'first-section' : ''} ${className}`} style={style}>
      <h3 className={`side-menu-section-title ${isMobileTitle ? 'side-menu-mobile-title' : ''}`}>
        {title}
      </h3>
      <div className="side-menu-items">
        {children}
      </div>
    </div>
  );
};
